import { apiInstance } from "@/api/instance";

export default async function (data) {
  return apiInstance.post("/review", data);
}
